











import Vue from 'vue';

// Components
import MOTMTable from './MOTMTable.vue';

export default Vue.extend({
	name: '',

	async mounted() {
		const manOfTheMatchId = this.$route.params.id;
		this.selectedMatch = await this.$store.dispatch('getManOfTheMatchById', { manOfTheMatchId });
	},

	data: () => ({
		selectedMatch: {} as any,
	}),

	components: {
		MOTMTable,
	},
});
